import styles from './SimBan.module.css'
import WaitLoader from "../../WaitLoader/WaitLoader";
import TableItem, {TableItemCurrentStateInt} from "../../FormTemplate/TableItem/TableItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import SimLastPayment from "../SimWork/SimLastPayment/SimLastPayment";
import SimLastVolume from "../SimWork/SimLastVolume/SimLastVolume";
import SelectUnit from "../../FormTemplate/SelectUnit/SelectUnit";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";

interface IBanItem {
    ban:string

    [key:string]:any
}

interface IBanList
{
    ban:string
    [key:string]:any
}


interface ISimItem {
    ctn:string
    [key:string]:any
}
interface IGetPacketData
{
    ban: string
}

export default function SimBan()
{
    const banListData =useRef(null)
    const [ldrBanList,rsBanList,exBanList] = useApiQuery("/core/ban/list","get",banListData);
    const [banList, setBanList] = useState<IBanList[]>([])

    const banPacketData =useRef<IGetPacketData>(null)
    const [ldrBanPacket,rsBanPacket,exBanPacket] = useApiQuery("/core/ban/packet/list","post",banPacketData);
    const [banPacket, setBanPacket] = useState<string[]>([])



    const [curBan , setCurBan] = useState<IBanItem>()
    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()

    const stateRef = useRef<ErrorLineItemRef>(null)
    const loggerRef = useRef<ILoggerItem>(null)



    useEffect(()=>{
        loadBanList()
    },[banListData])


    const loadBanPacketList = () =>{
        if(! curBan?.ban) return
        banPacketData.current = {
            ban: curBan?.ban
        }
        if(loggerRef.current)loggerRef.current.clear()
        exBanPacket().then((e)=>{
            if(e?.success)
            {
                if(loggerRef.current)loggerRef.current.log(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)
        })
    }

    const loadBanList = () =>{
        exBanList().then((e)=>{
            if(e?.success)
            {
                setBanList(e?.payload)
            }
        })
    }


    return(
        <div className={styles.mainCont} >

            <MainFormTemplate title={"Сим карты"} maxWidth={"1200px"} >
                <div className={styles.ldrCont}>
                    <ActiveRecordItem active={!!curBan}></ActiveRecordItem>
                    <div className={styles.ldr}>
                        <WaitLoader loading={ldrBanList || ldrBanPacket} api={rsBanList} onlyLoading={true}>

                        </WaitLoader>
                    </div>
                </div>

                <div className={styles.itmCont}>
                    <div className={styles.orTitle}>Общие данные</div>
                    <div className={"row w-100"}>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.ban ? curBan?.ban : ""  }
                                mode={"i"}
                                title={"Бан"}
                                info={"Бан"}
                            ></InputItem>
                        </div>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.login ? curBan?.login : ""  }
                                mode={"i"}
                                title={"Логин"}
                                info={"Логин"}
                            ></InputItem>
                        </div>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.pass ? curBan?.pass : ""  }
                                mode={"i"}
                                title={"Пароль"}
                                info={"Пароль"}
                            ></InputItem>
                        </div>

                    </div>
                    <div className={"row w-100"}>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.reportDay !==undefined ? (curBan?.reportDay == 0 ? "Последний день" : curBan?.reportDay) : ""  }
                                mode={"i"}
                                title={"День отчета"}
                                info={"День отчета"}
                            ></InputItem>
                        </div>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.totalCurUsage ? curBan?.totalCurUsage : "0"  }
                                mode={"i"}
                                title={"Трафик (Mb)"}
                                info={"Трафик (Mb)"}
                            ></InputItem>
                        </div>
                        <div className={"col-sm-4"}>
                            <InputItem
                                val={curBan?.totalCurUsage ? Math.round(curBan?.totalCurUsage/1000*100)/100 : "0"  }
                                mode={"i"}
                                title={"Трафик (Гб)"}
                                info={"Трафик (Гб)"}
                            ></InputItem>
                        </div>

                    </div>
                    <div className={"row w-100"}>
                        <div className={"col-sm-6"}>
                            <InputItem
                                val={curBan?.totalCurUsage ? curBan?.totalCurUsageBeeline : "0"  }
                                mode={"i"}
                                title={"Трафик (Mb) [Билайн]"}
                                info={"Трафик (Mb) [Билайн]"}
                            ></InputItem>
                        </div>
                        <div className={"col-sm-6"}>
                            <InputItem
                                val={curBan?.totalCurUsage ? Math.round(curBan?.totalCurUsageBeeline/1000*100)/100 : "0"  }
                                mode={"i"}
                                title={"Трафик (Гб) [Билайн]"}
                                info={"Трафик (Гб) [Билайн]"}
                            ></InputItem>
                        </div>

                    </div>
                </div>


                <div className={styles.itmCont}>
                    <div className={styles.orTitle}>Управление пакетами</div>
                    <div className={"row w-100"}>
                        <div className={"col-sm-4"}>
                            <LoggerItem
                                lineCount={5}
                                title={"Подключенные пакеты"}
                                ref={loggerRef}

                            />
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={curBan === undefined}
                                        onClick={loadBanPacketList}
                                >Запросить</button>


                            </div>
                        </div>
                    </div>

                </div>





                <div className={"row"} >
                    <ErrorLineItem ref={stateRef}></ErrorLineItem>
                </div>
            </MainFormTemplate>


            <WaitLoader loading={ldrBanList} api={rsBanList} onlyLoading={true}>
                <TableItem
                    data={banList}
                    column={[
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"ban",
                            title: "ban",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"login",
                            title: "login",
                            mode: "",
                        },
                        {
                            type: 6,
                            maxLen: 20,
                            fieldId:"pass",
                            title: "pass",
                            mode: "",
                        },
                        {
                            type: 1,
                            maxLen: 20,
                            fieldId:"reportDay",
                            title: "День отчета",
                            mode: "f",
                        },
                        {
                            type: 1,
                            maxLen: 20,
                            fieldId:"totalCurUsage",
                            title: "Трафик (Мб)",
                            mode: "s",
                        },
                        {
                            type: 5,
                            maxLen: 20,
                            fieldId:"active",
                            title: "Активен",
                            mode: "s",
                        },


                    ]}
                    onPageCount={25}
                    onReload={loadBanList}
                    exportExcel={true}
                    onRecord={(e)=>setCurBan(e)}
                    saveState={true}
                    baseState={{
                        state: baseState,
                        setState: setBaseState
                    }}




                ></TableItem>
            </WaitLoader>
        </div>
    )
}